const babackButtons = document.querySelectorAll('[is="baback-trigger"]');
if(babackButtons.length) {
  babackButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
    });
  });
}

(function() {
  const orders = document.querySelector('#orders')
  const home = document.querySelector('#home')
  const orderMenu = document.querySelector('#order-menu');
  const homeMenu = document.querySelector('#home-menu');

  if (window.location.hash === '#orders') {
    showOrders();
  }

  orderMenu.addEventListener('click', (e) => {
    if (window.location.hash === '') {
      window.history.pushState({}, '', window.location.href + '#orders')
      showOrders();
      e.preventDefault();
    }
  });

  homeMenu.addEventListener('click', (e) => {
    if (window.location.hash === '#orders') {
      window.history.pushState({}, '', window.location.href.replace('#orders', ''))
      showHome();
      e.preventDefault();
    }
  });

  function showOrders() {
    orders.classList.remove('hidden');
    home.classList.add('hidden');
    orderMenu.classList.add('customer__menu-item--active');
    homeMenu.classList.remove('customer__menu-item--active');
  }

  function showHome() {
    orders.classList.add('hidden');
    home.classList.remove('hidden');
    orderMenu.classList.remove('customer__menu-item--active');
    homeMenu.classList.add('customer__menu-item--active');
  }

  const menuHeading = document.querySelector('.customer__menu-heading');
  const menuList = document.querySelector('.customer__menu-list');

  menuHeading.addEventListener('click', () => {
    menuList.classList.toggle('customer__menu-list--active') 
  })
})();

async function checkElem (selector) {
  while (document.querySelector(selector) === null) {
      await new Promise(resolve => requestAnimationFrame(resolve))
  }
  return document.querySelector(selector);
}

checkElem('.cf-edit-account-link').then((elem) => {
    const customerMenuList = elem.closest('.customer__menu-list');
    let newItem = document.createElement('li');
    newItem.classList.add('customer__menu-item');
    newItem.appendChild(elem);
    customerMenuList.insertBefore(newItem, customerMenuList.children[2]);
});

const countryModals = document.querySelectorAll('x-modal[data-countries]');
const regionNames = new Intl.DisplayNames(['en'], { type: 'region' });

if(countryModals) {

  countryModals.forEach(function(modal) {
    const dataCountries = modal.dataset.countries;
    const countriesArray = dataCountries.split(',');
    const translatedCountriesArray = countriesArray.map(isoCode => {
      return regionNames.of(isoCode) || isoCode;  // Fallback to ISO code if no translation found
    });
    const translatedCountriesString = translatedCountriesArray.join(', ');
    const countrySelector = modal.querySelectorAll('country-selector select option');
    if(countrySelector){
      
      countrySelector.forEach(option => {
        if (!translatedCountriesString.toLowerCase().includes(option.value.toLowerCase())) {
          if(!option.value.includes("--")) {
            option.remove();
          }
        }
              
        if(option.value.includes("--")) {
          option.disabled = true;
          option.value = ""
        }

      });
    }

  });
}

// Newsletter Status Management
(async function() {
  const container = document.getElementById('newsletter-status-container');
  if (!container) return;

  const translations = window.themeVariables.strings;
  const statusMessage = document.getElementById('newsletter-status-message');
  const pendingSection = document.getElementById('newsletter-pending-section');
  const subscribeTrigger = document.getElementById('newsletter-subscribe-trigger');

  // Vérifier si l'email de confirmation a été renvoyé
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('newsletter_resent') === 'true') {
    const notification = document.getElementById('newsletter-notification');
    if (notification) {
      notification.style.display = 'block';
      // Scroll vers la notification
      setTimeout(() => {
        notification.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 100);
    }
  }

  try {
    const response = await fetch('/apps/abapp/getNewsletterStatus', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`API Error: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();
    const statusContainer = document.getElementById('newsletter-status-content');
    const loadingContainer = document.getElementById('newsletter-status-loading');

    // Cacher le loader
    loadingContainer.style.display = 'none';
    statusContainer.style.display = 'block';

    // Afficher le statut selon la réponse
    switch(data.marketingState) {
      case 'SUBSCRIBED':
        statusMessage.innerHTML = translations.newsletterSubscribed;
        statusMessage.style.display = 'block';
        break;
      case 'PENDING':
        statusMessage.innerHTML = translations.newsletterPending;
        statusMessage.style.display = 'block';
        pendingSection.style.display = 'block';
        
        // Activer le bouton submit quand la checkbox est cochée
        const checkbox = pendingSection.querySelector('input[name="confirm_resend_newsletter"]');
        const submitBtn = document.getElementById('submit-resend-newsletter');
        
        if (checkbox && submitBtn) {
          checkbox.addEventListener('change', (e) => {
            submitBtn.disabled = !e.target.checked;
            // Utiliser les classes CSS au lieu des styles inline
            if (e.target.checked) {
              submitBtn.classList.remove('button--disabled');
            } else {
              submitBtn.classList.add('button--disabled');
            }
          });
        }
        break;
      case 'NOT_SUBSCRIBED':
      case 'UNSUBSCRIBED':
      case 'INVALID':
      default:
        statusMessage.innerHTML = translations.newsletterNotSubscribed;
        statusMessage.style.display = 'block';
        subscribeTrigger.style.display = 'inline-block';
        subscribeTrigger.addEventListener('click', (e) => {
          e.preventDefault();
          openNewsletterPopup();
        });
        break;
    }
  } catch (error) {
    console.error('Erreur lors de la récupération du statut newsletter:', error);
  }
})();

// Fonction pour ouvrir la pop-in newsletter
function openNewsletterPopup() {
  const popup = document.querySelector('newsletter-popup');
  if (popup) {
    popup.show();
  }
}
